import React from 'react';

import { IMobileSdkTestDetails } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { DashboardTableLabel } from 'src/common/components/DashboardTableLabel/DashboardTableLabel';
import { IReportInfo } from 'src/common/components/report-info/ReportInfo';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import './MobileSdkSingleTestHeader.scss';

export const getMobileSdkInfoItems = (): IReportInfo[] => {
	return [
		{
			key: 'lastModified',
			label: 'Test date',
			textFormatter: formatShortMonthDatetime
		},
		{
			key: 'sdk',
			label: 'SDK',
			customValueRenderer: ({ sdkType, productVersion }: IMobileSdkTestDetails) => {
				// todo: replace with formatter
				return (
					<>
						<p>{sdkType}</p>
						<p>{productVersion}</p>
					</>
				);
			}
		},
		{
			key: 'app',
			label: 'App',
			customValueRenderer: ({ appName, appVersion }: IMobileSdkTestDetails) => {
				// todo: replace with formatter
				return (
					<>
						<p>{appName}</p>
						<p>{appVersion}</p>
					</>
				);
			}
		},
		{
			key: 'labels',
			label: 'Test labels',
			customValueRenderer: (test: IMobileSdkTestDetails) => {
				const labels = test.labels || [];
				return <DashboardTableLabel labels={labels} />;
			}
		}
	];
};
